// extracted by mini-css-extract-plugin
export default {"mid-box":"HospitalLinkComplete_mid-box__BZDgs","top":"HospitalLinkComplete_top__lRgm7","botm":"HospitalLinkComplete_botm__LtVLU"};